import React, { useState } from 'react';
import {
  Modal,
  Link,
  ModalHeader,
  ModalBody,
  Typography
} from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';

export const CalculatorModal = () => {

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <div className="sui-flex sui-items-center sui-pt-1">
        {/* @todo: clean inline style once Stencil fixes the icon invisible bottom padding */}
        <div className="sui-mr-1" style={{ 'margin-bottom': '-5px' }}><InfoFilled size="small" color="info" /></div>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link component="button" color="info" underline="none" onClick={handleOpen}>Measuring Tips</Link>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
      >
        <ModalHeader onClose={handleClose}>How to Measure Backsplash Dimensions</ModalHeader>
        <ModalBody data-component="CalculatorModal">
          <Typography variant="body-base">
            1. Determine which kitchen type you are measuring.<br />
            2. Using a measuring tape, measure the width and height of each area in inches.<br />
            3. Input each area dimensions into Home Depot calculator.
          </Typography>
          <div className="sui-grow">
            <div className="sui-font-bold sui-pt-3 sui-pb-3">Kitchen Type 1</div>
            <img
              src="https://assets.homedepot-static.com/images/v1/kitchen-type-1-calculator.svg"
              alt="kitchen type 1"
              width="100%"
              height="auto"
            />
            <div className="sui-font-bold sui-pt-3 sui-pb-3">Kitchen Type 2</div>
            <img
              src="https://assets.homedepot-static.com/images/v1/kitchen-type-2-calculator.svg"
              alt="kitchen type 2"
              width="100%"
              height="auto"
            />
            <div className="sui-font-bold sui-pt-3 sui-pb-3">Kitchen Type 3</div>
            <img
              src="https://assets.homedepot-static.com/images/v1/kitchen-type-3-calculator.svg"
              alt="kitchen type 3"
              width="100%"
              height="auto"
            />
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};
